/**
 * @generated SignedSource<<f8c23088780b6ba68c4b8715d0b023d6>>
 * @relayHash 1ab5a3c31c93d15066415c7122f4c697
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e45293f8a27ead7abd3ce9b719eca0f4e86961473ff018b8fd9a39c723ca81a9

var node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "forgeExtensionRenderingContext"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "uiModificationsContext"
    }],
    v1 = {
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    },
    v2 = {
      "kind": "ScalarField",
      "name": "id"
    },
    v3 = {
      "kind": "ScalarField",
      "name": "type"
    };
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "name": "rootUiModificationsQuery",
      "selections": [{
        "args": [v1 /*: any*/, {
          "kind": "Variable",
          "name": "forgeExtensionRenderingContext",
          "variableName": "forgeExtensionRenderingContext"
        }, {
          "kind": "Variable",
          "name": "uiModificationsContext",
          "variableName": "uiModificationsContext"
        }],
        "kind": "FragmentSpread",
        "name": "fragment_AtlassianUiModificationsCore_RootFragment"
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "rootUiModificationsQuery",
      "selections": [{
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [{
          "args": [{
            "kind": "Variable",
            "name": "context",
            "variableName": "uiModificationsContext"
          }],
          "concreteType": "JiraAppUiModifications",
          "kind": "LinkedField",
          "name": "uiModifications",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "name": "appEnvId"
          }, {
            "concreteType": "JiraUiModification",
            "kind": "LinkedField",
            "name": "uiModifications",
            "plural": true,
            "selections": [v2 /*: any*/, {
              "kind": "ScalarField",
              "name": "data"
            }]
          }]
        }, {
          "concreteType": "JiraForgeQuery",
          "kind": "LinkedField",
          "name": "forge",
          "plural": false,
          "selections": [{
            "alias": "uiModificationsExtensions",
            "args": [v1 /*: any*/, {
              "kind": "Variable",
              "name": "context",
              "variableName": "forgeExtensionRenderingContext"
            }, {
              "kind": "Literal",
              "name": "types",
              "value": ["jira:uiModifications"]
            }],
            "concreteType": "JiraForgeExtension",
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [v2 /*: any*/, {
              "kind": "ScalarField",
              "name": "appVersion"
            }, {
              "kind": "ScalarField",
              "name": "installationId"
            }, {
              "kind": "ScalarField",
              "name": "environmentId"
            }, {
              "kind": "ScalarField",
              "name": "environmentType"
            }, {
              "kind": "ScalarField",
              "name": "environmentKey"
            }, {
              "concreteType": "JiraForgeExtensionLicense",
              "kind": "LinkedField",
              "name": "license",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "name": "active"
              }, v3 /*: any*/, {
                "kind": "ScalarField",
                "name": "supportEntitlementNumber"
              }, {
                "kind": "ScalarField",
                "name": "trialEndDate"
              }, {
                "kind": "ScalarField",
                "name": "subscriptionEndDate"
              }, {
                "kind": "ScalarField",
                "name": "isEvaluation"
              }, {
                "kind": "ScalarField",
                "name": "billingPeriod"
              }, {
                "kind": "ScalarField",
                "name": "ccpEntitlementId"
              }, {
                "kind": "ScalarField",
                "name": "ccpEntitlementSlug"
              }, {
                "kind": "ScalarField",
                "name": "capabilitySet"
              }]
            }, {
              "kind": "ScalarField",
              "name": "properties"
            }, {
              "kind": "ScalarField",
              "name": "scopes"
            }, v3 /*: any*/, {
              "concreteType": "JiraForgeAppEgressDeclaration",
              "kind": "LinkedField",
              "name": "egress",
              "plural": true,
              "selections": [v3 /*: any*/, {
                "kind": "ScalarField",
                "name": "addresses"
              }, {
                "kind": "ScalarField",
                "name": "category"
              }, {
                "kind": "ScalarField",
                "name": "inScopeEUD"
              }]
            }, {
              "concreteType": "JiraForgeInstallationConfigExtension",
              "kind": "LinkedField",
              "name": "installationConfig",
              "plural": true,
              "selections": [{
                "kind": "ScalarField",
                "name": "key"
              }, {
                "kind": "ScalarField",
                "name": "value"
              }]
            }, {
              "kind": "ScalarField",
              "name": "consentUrl"
            }, {
              "concreteType": "JiraUserAppAccess",
              "kind": "LinkedField",
              "name": "userAccess",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "name": "hasAccess"
              }, {
                "kind": "ScalarField",
                "name": "enabled"
              }]
            }, {
              "kind": "ScalarField",
              "name": "hiddenBy"
            }]
          }]
        }]
      }]
    },
    "params": {
      "id": "e45293f8a27ead7abd3ce9b719eca0f4e86961473ff018b8fd9a39c723ca81a9",
      "metadata": {},
      "name": "rootUiModificationsQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "9036ea3b10c5003976e51018f89bdc35";
export default node;